var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/Caregiver/CaregiverConnection/index.tsx";
import React, { useEffect, useState } from 'react';
import { Divider, LoadingSpinner, Stack, Text } from '@adc/parallax-component-library';
import { ApiStatus } from 'Enums';
import { useApiError, useCaregiver, useToast } from 'Hooks';
import { Link, Main, Spinner, TitleActionBar } from 'Components/utility';
import { cutString } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { logout } from 'Utilities/session';
const CaregiverConnection = ({
  data: {
    caregiverConnection
  }
}) => {
  const [footerLoading, setFooterLoading] = useState(false);
  const [mainLoading, setMainLoading] = useState(true);
  const {
    showApiErrorModal
  } = useApiError();
  const {
    showToast
  } = useToast();
  const {
    removeCaregiverConnection,
    showStopSharingModal
  } = useCaregiver();
  useEffect(() => {
    if (!caregiverConnection) {
      mediator.publish('router:navigate', '/connections');
    }
    setMainLoading(false);
  }, [caregiverConnection]);
  const onStopSharing = () => {
    showStopSharingModal(async () => {
      try {
        setFooterLoading(true);
        await removeCaregiverConnection(caregiverConnection);
        showToast({
          message: i18n.t('Global.modals.removeConnection.connectionRemoved'),
          'aria-label': i18n.t('Global.modals.removeConnection.connectionRemoved')
        });
        mediator.publish('router:navigate', '/connections');
      } catch (err) {
        const error = err;
        if (error.status === ApiStatus.UNAUTHORIZED) {
          logout();
          return;
        }
        showApiErrorModal();
      } finally {
        setFooterLoading(false);
      }
    });
  };
  if (mainLoading) {
    return /*#__PURE__*/React.createElement(Spinner, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 12
      }
    });
  }
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(TitleActionBar, {
    testID: "ConnectedCaregiver",
    title: `${cutString(caregiverConnection.firstName, 10)} ${cutString(caregiverConnection.lastName, 10)}`,
    closeBtn: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Stack, {
    margin: "$4",
    padding: "$4",
    backgroundColor: "$surface.container",
    border: "$1.5",
    shadow: "$-1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "ConnectedCaregiver.title",
    color: "$text.100",
    fontWeight: "$h3.strong",
    fontSize: "$h3.strong",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 9
    }
  }, i18n.t('Connections.content.connectedCaregiver.primaryText')), /*#__PURE__*/React.createElement(Text, {
    testID: "ConnectedCaregiver.bodyText",
    marginTop: "$2",
    color: "$text.100",
    fontWeight: "$bodyBase.default",
    fontSize: "$bodyBase.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 9
    }
  }, i18n.t('Connections.content.connectedCaregiver.secondaryText')), /*#__PURE__*/React.createElement(Text, {
    testID: "ConnectedCaregiver.email-label",
    marginTop: "$8",
    color: "$text.60",
    fontWeight: "$bodySmall.default",
    fontSize: "$bodySmall.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 9
    }
  }, i18n.t('Connections.content.connectedCaregiver.bodyText')), /*#__PURE__*/React.createElement(Text, {
    testID: "ConnectedCaregiver.email",
    color: "$text.100",
    fontWeight: "$bodyBase.medium",
    fontSize: "$bodyBase.medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 9
    }
  }, caregiverConnection.email), /*#__PURE__*/React.createElement(Divider, {
    marginVertical: "$4",
    borderColor: "$neutral.40",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 9
    }
  }), footerLoading ? /*#__PURE__*/React.createElement(Stack, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 121,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(LoadingSpinner, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 122,
      columnNumber: 13
    }
  })) : /*#__PURE__*/React.createElement(Link, {
    testID: "ConnectedCaregiver.stopSharing-btn",
    onPress: onStopSharing,
    linkTextColor: "$support.danger.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 125,
      columnNumber: 11
    }
  }, i18n.t('Connections.content.connectedCaregiver.links.stopSharing.label'))));
};
export default CaregiverConnection;